import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";

import { useSessionScope } from "@/lib/session-scope";
import { Button } from "@/components/ui/button";

/** Header chip: current scope + a way to switch it. */
export function ScopeSwitcher() {
  const { scope } = useSessionScope();
  if (!scope) return null;
  return (
    <Button
      nativeButton={false}
      variant="outline"
      size="sm"
      className="hidden max-w-72 min-w-0 gap-1.5 sm:inline-flex"
      render={<Link to="/select-scope?next=/" title="Change legal entity / operation unit / department" />}
    >
      <Building2 className="shrink-0" />
      <span className="max-w-32 shrink-0 truncate">{scope.operationUnit.name}</span>
      {/* Three names don't fit — with a department, show OU · department (LE stays on the page heading). */}
      {scope.department ? (
        <span className="truncate text-muted-foreground">· {scope.department.name}</span>
      ) : (
        <span className="hidden truncate text-muted-foreground lg:inline">· {scope.legalEntity.name}</span>
      )}
    </Button>
  );
}
